import { css } from '@compiled/react';
import React from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

const wrapperStyles = css({
	position: 'relative',
	marginTop: token('space.300'),
});

const labelStyles = css({
	boxShadow: `0 0 0 1px ${token('color.border')}`,
	borderTopLeftRadius: token('radius.small'),
	borderTopRightRadius: token('radius.small'),
	textTransform: 'capitalize',
	marginLeft: token('space.200'),
	marginRight: token('space.025'),
	paddingLeft: token('space.025'),
	paddingRight: token('space.025'),
	paddingTop: token('space.negative.025'),
	paddingBottom: token('space.negative.025'),
	position: 'absolute',
	top: '-23px',
});

const bodyStyles = css({
	boxShadow: `0 0 0 1px ${token('color.border')}`,
	borderRadius: token('radius.small'),
	marginLeft: token('space.025'),
	marginRight: token('space.025'),
	marginBottom: token('space.100'),
	marginTop: token('space.400'),
	padding: token('space.050'),
	maxWidth: `100%`,
	overflow: 'visible',
});

type Props = {
	macroTitle: string;
	children?: React.ReactNode;
};

export function UnknownMacroPlaceholder({ macroTitle, children }: Props): React.JSX.Element {
	return (
		<div css={wrapperStyles}>
			<span css={labelStyles}>
				<Text color="color.text.subtle" size="small">
					{macroTitle}
				</Text>
			</span>
			<div css={bodyStyles}>{children}</div>
		</div>
	);
}
